import { createContext, use } from 'react';

export const UploadOpener = createContext<((files: File[]) => void) | null>(null);

/** Opens the upload dialog for files, from inside an <AttachmentDropZone>; null outside one. */
export function useOpenUpload(): ((files: File[]) => void) | null {
  return use(UploadOpener);
}
